import { createRouter, createWebHistory } from 'vue-router';
import Home from './layouts/Home.vue';
import NoAutorizadoView from './layouts/NoAutorizado.vue';

// Lazy loading de componentes para evitar problemas de hidratación
const UsuariosView = () => import('./views/Usuarios.vue');
const RolesView = () => import('./views/Roles.vue');
const TalleresView = () => import('./views/Talleres.vue');
const HorariosView = () => import('./views/Horarios.vue');
const AlumnosView = () => import('./views/Alumnos.vue');
const PagosView = () => import('./views/Pagos.vue');
const MiTaller1View = () => import('./views/MiTaller1.vue');
const MiTaller2View = () => import('./views/MiTaller2.vue');
const MiTaller3View = () => import('./views/MiTaller3.vue');
const CoordinacionView = () => import('./views/Coordinacion.vue');
const ReporteGeneralView = () => import('./views/ReporteGeneral.vue');
const AsistenciaReporteView = () => import('./views/AsistenciaReporte.vue');

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/usuarios', name: 'usuarios', component: UsuariosView },
    { path: '/roles', name: 'roles', component: RolesView },
    { path: '/talleres', name: 'talleres', component: TalleresView },
    { path: '/horarios', name: 'horarios', component: HorariosView },
    { path: '/alumnos', name: 'alumnos', component: AlumnosView },
    { path: '/pagos', name: 'pagos', component: PagosView },
    { path: '/mitaller', name: 'mitaller', component: MiTaller1View },
    { path: '/mitaller2', name: 'mitaller2', component: MiTaller2View },
    { path: '/mitaller3', name: 'mitaller3', component: MiTaller3View },
    { path: '/coordinacion', name: 'coordinacion', component: CoordinacionView },
    { path: '/reportegeneral', name: 'reportegeneral', component: ReporteGeneralView },
    { path: '/asistencia-reporte', name: 'asistencia-reporte', component: AsistenciaReporteView },
    { path: '/no-autorizado', name: 'no-autorizado', component: NoAutorizadoView },

  ]
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (!token && to.path !== '/login') {
    return next('/login');
  }
  
  // Permisos: la clave es el path, el valor es array de permisos
  const permisos = JSON.parse(localStorage.getItem('permisos') || '{}');
  
  // Rutas que no requieren permisos específicos (accesibles para todos los usuarios autenticados)
  const rutasLibres = ['/', '/login', '/mitaller', '/mitaller2', '/mitaller3', '/asistencia-reporte', '/no-autorizado'];
  
  // Si la ruta requiere permiso y no está en la lista, redirigir
  if (!rutasLibres.includes(to.path)) {
    if (!permisos[to.path]) {
      // Si no tiene permiso para la ruta, redirigir a home solo si no está en home
      return next({ path: '/no-autorizado' });
    }
  }
  next();
});

export default router;
